import { Page } from '@/domains';
import { authorizedApi } from '@/services/network/authorized-api';
import { AuditLog, FilterAuditLogsParams } from '@/types/audit';

export const fetchAuditLogs = async (params: FilterAuditLogsParams): Promise<Page<AuditLog>> =>
  await authorizedApi.get('/admin/audit-logs', params);
